import AppDownSection from './app-down';
import HomeBanner from './banner';
import { HomeScreenFAQ } from './faq-section';
import OtmRecBanner from './otm-rec-banner';
import TestsCategoryCard from './tests-category-card';
import TopicTestBanner from './topic-test-banner';
import Universities from './universities';

const HomeComponents = () => (
  <>
    <div className="max-w-screen m-2 md:mx-auto">
      <HomeBanner />
      <TestsCategoryCard />
      <Universities />
      <OtmRecBanner />
      <AppDownSection />
      <TopicTestBanner />
    </div>
    <HomeScreenFAQ />
  </>
);

export default HomeComponents;
